import React from "react";
import Nav from "../nav/Nav";
import Sidebar from "../aside/Sidebar";
import Footer from "../footer/Footer";
import { Link } from "react-router-dom";

function NotFounded() {
  return (
    <>
      <Sidebar />

      <div className="content-wrapper" style={{ minHeight: "543px" }}>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>صفحه ارور ۴۰۴</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-left">
                  <li className="breadcrumb-item">
                    <Link to="/">خانه</Link>
                  </li>
                  <li className="breadcrumb-item active">صفحه ارور ۴۰۴</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="error-page">
            <h2 className="headline text-warning"> ۴۰۴</h2>

            <div className="error-content">
              <h3>
                <i className="fa fa-warning text-warning"></i> آخ! صفحه مورد
                نظرتون شما یافت نشد.
              </h3>

              <p>
                متاسفانه صفحه مورد نظر شما در سایت وجود ندارد میتوانید به
                <Link to="/">  خانه </Link>   برگردید
              . </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default NotFounded;
